/**
 * 用户相关信息
 */
import CUser from '@/utils/User';
import Y from '@/utils/Y';
import router from '@/router/index';
import { postMemberLogin, postMemberLogout,postMemberBind, postEnterpriseLogin,postEnterpriseBind } from '@/api/user/login';
import { getMemberGetInfo, getCorporateList } from '@/api/user/user';
import store from '@/store/index';
import FileInfo from '@/utils/GetFileUrl.js';

const User = {
	namespaced: true,
	state: {
		// 用户信息
		info: CUser.getUserInfo(),

		//企业列表
		corporateList: CUser.getCorporateList(),

		//当前登录企业信息索引
		corporate: CUser.getCorporate(),

		// 是否登录
		isLogin: CUser.isLogin(),

		// 登录hash
		token: CUser.getToken(),

		// 是否VIP
		isVIP: false
	},

	getters: {
		// 获得当前用户信息
		uinfo(state) {
			return state.info;
		},

		// 获得企业列表
		cList(state) {
			return state.corporateList;
		},

		// 获得当前登录企业信息索引
		cinfo(state) {
			return state.corporate;
		},

		// 返回当前登录状态
		uisLogin(state) {
			// console.log('isLogin:', state.isLogin);
			return !!state.token;
		},

		// 获得当前的Login Hash
		utoken(state) {
			// console.log('token:', state.token);
			return state.token;
		},

		// 获得当前用户是否为VIP
		uisVIP(state) {
			return state.isVIP;
		}
	},

	mutations: {
		// 退出登录
		loginOut(state) {
			state.info = { user_id: 0 };
			state.isLogin = false;
			state.token = '';
			CUser.logout();
		},

		// 设置登录token
		setToken(state, token) {
			state.token = token;
		},

		// 设置登录状态
		setIsLogin(state, isLogin) {
			state.isLogin = isLogin;
		},

		// 设置用户信息
		setInfo(state, uinfo) {
			state.info = uinfo;
		},

		// 设置企业列表
		setCorporateList(state, cList) {
			state.corporateList = cList;
		},

		// 设置当前登录企业信息索引
		setCorporate(state, cindex) {
			state.corporate = cindex;
		}
	},

	actions: {
		// 登录
		login({ commit }, loginInfo) {
			return new Promise((resolve, reject) => {
				postMemberLogin(loginInfo)
					.then(res => {
						if (res.code > 600) {
							reject(res);
						}else {
							const data = res.data.access_token;
							CUser.setToken(data);
							commit('setToken', data);
							commit('setIsLogin', true);
							// store.dispatch('Cart/getCartList');
							resolve();
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		//绑定微信
		bindWechat({ commit }, loginInfo) {
			return new Promise((resolve, reject) => {
				postMemberBind(loginInfo)
					.then(res => {
						if (res.code > 600) {
							reject(res);
						} else {
							resolve();
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		// 企业登录
		enterpriseLogin({ commit }, loginInfo) {
			return new Promise((resolve, reject) => {
				postEnterpriseLogin(loginInfo)
					.then(res => {
						if (res.code > 600) {
							reject(res);
						} else {
							const data = res.data.access_token;
							CUser.setToken(data);
							commit('setToken', data);
							commit('setIsLogin', true);
							resolve();
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		//企业微信绑定
		enterpriseBindWechat({ commit }, loginInfo) {
			return new Promise((resolve, reject) => {
				postEnterpriseBind(loginInfo)
					.then(res => {
						if (res.code > 600) {
							reject(res);
						} else {
							resolve();
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		},
	

		// 获取用户信息
		getUserInfo({ commit, state }) {
			return new Promise((resolve, reject) => {
				getMemberGetInfo()
					.then(res => {
						// console.log('用户信息-vuex',res)
						let data = res.data;
						// 设置是否VIP
						// 检查levelId是否为非0
						
						const hasValidLevelId = data.levelId && data.levelId !== 0;
						// 检查levelEnd是否有效（大于当前时间）
						const now = new Date().getTime();
						const levelEndValid = data.levelEnd && new Date(data.levelEnd).getTime() > now;
						state.isVIP = hasValidLevelId && levelEndValid;
						CUser.setUserInfo(data);
						commit('setInfo', data);
						resolve(res);
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		//退出登录
		logout({ commit, state }) {
			return new Promise((resolve, reject) => {
				postMemberLogout()
					.then(res => {
						CUser.logout();
						commit('setToken', '');
						commit('setInfo', { id: 0 });
						commit('setCorporate', {}); // 清除企业缓存
						//如果路径是index/VIPList 则不跳转
						// console.log('currentRoute.path:', router);
						if (router.currentRoute.path !== '/VIPList') {
							router.push({ path: '/Home' });
						}
						resolve();
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		// 获取企业列表
		getCorporateList({ commit, state }) {
			return new Promise((resolve, reject) => {
				getCorporateList()
					.then(res => {
						let data = res.data;
						CUser.setCorporateList(data);
						commit('setCorporateList', data);
						resolve(res);
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		// 设置当前登录企业信息索引
		chooseCorporate({ commit, state }, cinfo) {
			CUser.setCorporate(cinfo);
			commit('setCorporate', cinfo);
		},

		loginByToken(commit, pm) {
			// 更新token
			CUser.setToken(pm.token);
			commit('setToken', pm.token);

			// IUser.fgetUserInfo().then(rlt => {
			// 	if (rlt.code == 200) {
			// 		let uinfo = rlt.data.user;

			// 		// 添加用户信息
			// 		CUser.setUserInfo(uinfo);
			// 		commit('setInfo', uinfo);

			// 		// 登录成功执行函数
			// 		if (typeof pm.onSuccess == 'function') {
			// 			pm.onSuccess(uinfo);
			// 		}

			// 		Y.msg.success('恭喜！登录成功');
			// 	} else {
			// 		Y.msg.warning(rlt.msg);
			// 	}
			// });
		}
	}
};

export default User;
